// extracted by mini-css-extract-plugin
export default {"card3":"qNC3ko0N","altheadline":"gyXUFLTC","link":"l15QZGjS","info":"igMbzYn4"};